export default __webpack_public_path__ + "static/media/muster-overview-header-graphic.1631e2bd.png";